/* eslint-disable max-len */
/* eslint-disable react/prop-types */
// AsignarPruebasPorVacanteModal.jsx
import {
  Badge,
  Checkbox,
  Modal,
  Typography,
  notification,
} from 'antd';
import { postSolicitudPrueba } from 'api/catalogos/Pruebas';
import React, { useState } from 'react';
import Table from 'components/Table';
import FormSubmitControls from 'components/FormSubmitControls';

const { Text } = Typography;

export default function AsignarPruebasPorVacanteModal({
  isOpen,
  onClose,
  vacante,
  pruebasDisponibles,
  onAsignarSuccess,
}) {
  const [selectedPruebas, setSelectedPruebas] = useState([]);

  if (!vacante) return null; //  Esto evita el error

  const togglePrueba = (id) => { setSelectedPruebas((prev) => (prev.includes(id) ? prev.filter((pid) => pid !== id) : [...prev, id])); };

  const handleAsignar = async () => {
    try {
      const peticiones = selectedPruebas.map((pruebaId) => postSolicitudPrueba({
        solicitud_de_contratacion: vacante.solicitud_de_contratacion,
        pruebas_y_otros: pruebaId,
      }));

      await Promise.all(peticiones);

      notification.success({
        message: 'Pruebas asignadas correctamente',
        description: `Se asignaron ${selectedPruebas.length} prueba(s) a la solicitud `,
        placement: 'bottomRight',
      });

      setSelectedPruebas([]);
      onClose();
      onAsignarSuccess(); // Callback para actualizar la lista de pruebas asignadas
    } catch (error) {
      notification.error({
        message: 'Error al asignar pruebas',
        description: 'No se pudieron asignar las pruebas. Intenta de nuevo.',
        placement: 'bottomRight',
      });
    }
  };

  const columnsPruebas = [
    {
      title: (
        <Checkbox
          checked={selectedPruebas.length === pruebasDisponibles.length}
          onChange={(e) => setSelectedPruebas(e.target.checked ? pruebasDisponibles.map((p) => p.id) : [])}
        />
      ),
      dataIndex: 'id',
      render: (_, record) => (
        <Checkbox
          checked={selectedPruebas.includes(record.id)}
          onChange={() => togglePrueba(record.id)}
        />
      ),
      width: 50,
    },
    // {
    //   title: 'Nombre',
    //   dataIndex: 'nombre',
    // },
    // {
    //   title: 'Tipo',
    //   dataIndex: 'tipo',
    //   render: (tipo) => {
    //     const tipoColorMap = {
    //       Técnica: 'blue',
    //       Psicométrica: 'purple',
    //       Idioma: 'green',
    //       Aptitud: 'orange',
    //     };
    //     return <Badge color={tipoColorMap[tipo] || 'default'} text={tipo} />;
    //   },
    // },
    // {
    //   title: 'Duración',
    //   dataIndex: 'duracion',
    // },
    {
      title: 'Descripción',
      dataIndex: 'descripcion',
    },
  ];

  return (
    <Modal
      open={isOpen}
      closable={false}
      maskClosable
      keyboard
      footer={null}
      title={(
        <FormSubmitControls
          label="Asignar Pruebas a la Vacante"
          onFinish={handleAsignar}
          onCancel={onClose}
        // loading={loading}
          onFinishText="Guardar y Continuar"
        />
    )}
      onCancel={onClose}
      forceRender
      width={800}
    >
      <Text>Selecciona una o más pruebas para asignarlas a la vacante:</Text>
      <Table
        cols={columnsPruebas}
        data={pruebasDisponibles}
        rowKey="id"
        pagination={false}
        bordered
        style={{ marginTop: 20 }}
      />
    </Modal>
  );
}
